/** A small ring that spins, unless the person has asked for less motion. */
export function PhotoSpinner({ size = 22 }: { size?: number }) {
  return <span aria-hidden="true" className="vbc-spinner" style={{ width: size, height: size }} />;
}
